export default "__VITE_ASSET__BY4ikOZO__"